export class CircleManagement {
    public id =''
    public childrenList=''
    public createdDate =''
    public imageCapture=''
    public imageCaptureList=''
    public isReply=''
    public parentId=''
    public replyId=''
    public replyUserName=''
    public userCompany=''
    public userId=''
    public userMessage=''
    public userName=''
}